/* eslint-disable max-len */
import { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import { Generals } from '../../enums/general.names.enum';
import expandButton from '../../Assets/AlertIcon/Expand Button.svg';
import ActiveAlarmsCard from '../../Components/ActiveAlarmsCard';
import ActiveAlarmsTable from '../../Components/ActiveAlarmsTable';
import io from 'socket.io-client';
import IpranMap from '../../Components/Map/IpranMap';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import './styles.css';
import dayjs from 'dayjs';
import { useAtom } from 'jotai';
import { loadingApiAtom } from '../../common/atom/atoms';
import apiClient from '../../common/functions/api_axios_instance.function';
import { useNavigate } from 'react-router-dom';
import { addMinutesToDateTime } from '../../common/functions/add_minutes.function';
import { handleApiError } from '../../common/functions/errorHandler.function';
import NetworkMonitoringButtons from './NetworkMonitoringButtons';
import { hasNetworkMonitoringPermissions } from '../../common/functions/permission_utils.function';
import FilterDrawer from '../../Components/FilterDrawer';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import HeadingFttsLandingPageButton from './headingFttsLandingPageButton';
import { isNewFttsImplementation } from '../../common/functions/ftts_new_implementation.function';
import { isNewIpranImplementation } from '../../common/functions/ipran_new_implementation.function';
import { isNewOtnImplementation } from '../../common/functions/otn_new_implementation.function';
let alarmsAllData = [];
export default function FttsLandingPage() {
  const selectedTab = sessionStorage.getItem('selectedTab');
  const apiUrl = process.env.REACT_APP_API_URL;
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const defaultDate = dayjs();
  const [loadingApi, setLoadingApi] = useAtom(loadingApiAtom);
  const socketRef = useRef(null);
  const [tabCheck, setTabCheck] = useState(selectedTab);
  const [open, setOpen] = useState(false);
  const [viewType, setViewType] = useState(Generals.map);
  const [data, setData] = useState(alarmsAllData ? alarmsAllData : null);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState([defaultDate, defaultDate]);
  const [totalAlarms, setTotalAlarms] = useState(0);
  const [region, setRegion] = useState('');
  const markerRef = useRef(null);
  const [city, setCity] = useState('');
  const [videoPlayed, setVideoPlayed] = useState(false);
  const [ring, setRing] = useState('');
  const [link, setLink] = useState('');
  const [site, setSite] = useState('');
  const permissionsJSON = localStorage.getItem('permissions');
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];
  const [valueTab, setValueTab] = useState('');
  const [selectedAlarm, setSelectedAlarm] = useState(null);
  // Initialize video play times based on current date
  const now = dayjs();
  const twentyFourHoursAgo = now.subtract(24, 'hour');
  const [videoPlayTime, setVideoPlayTime] = useState(
    `${twentyFourHoursAgo.format('YYYY-MM-DD')} ${twentyFourHoursAgo.format('HH:mm:ss')}`
  );
  const [videoPlayTimeFromStart, setVideoPlayTimeFromStart] = useState(
    `${twentyFourHoursAgo.format('YYYY-MM-DD')} ${twentyFourHoursAgo.format('HH:mm:ss')}`
  );
  const [videoPlayTimeEnd, setVideoPlayTimeEnd] = useState(
    `${now.format('YYYY-MM-DD')} ${now.format('HH:mm:ss')}`
  );
  const [alramType, setAlramType] = useState(Generals.live);
  const [filtersData, setFiltersData] = useState(null);
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);
  const [rings, setRings] = useState([]);
  const [sites, setSites] = useState([]);
  const [links, setLinks] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [applyFilters, setApplyFilters] = useState(false);
  const navigate = useNavigate();
  const [initialFilters, setInitialFilters] = useState({
    region: [],
    city: [],
    ring: [],
    site: [],
    link: [],
  });
  const [filtersValue, setFiltersValue] = useState({
    region: '',
    city: '',
    ring: '',
    site: '',
    link: '',
  });
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  useEffect(() => {
    setTabCheck(selectedTab);
  }, [selectedTab]);
  useLayoutEffect(() => {
    if (!permissionNames.length) {
      navigate('/rov');
      return;
    }
    if (!hasNetworkMonitoringPermissions(permissionNames)) {
      navigate('/rov');
      return;
    }
    if (selectedTab) {
      setValueTab(selectedTab);
      return;
    }
    if (permissionNames.includes('FTTS')) {
      sessionStorage.setItem('selectedTab', 'ftts');
      setValueTab('ftts');
      return;
    }
    if (permissionNames.includes('MPBN')) {
      sessionStorage.setItem('selectedTab', 'mpbn');
      setValueTab('mpbn');
      return;
    }
    if (permissionNames.includes('OTN')) {
      sessionStorage.setItem('selectedTab', 'otn');
      setValueTab('otn');
      return;
    }
    if (permissionNames.includes('IPRAN')) {
      sessionStorage.setItem('selectedTab', 'ipran');
      setValueTab('ipran');
      return;
    }
  });

  // Handle selectedDate changes to update video play times
  useEffect(() => {
    if (!selectedDate || !Array.isArray(selectedDate) || selectedDate.length !== 2) {
      console.warn('Invalid selectedDate format in FttsLandingPage:', selectedDate);
      return;
    }

    const [startDate, endDate] = selectedDate;

    // Check if both dates are valid dayjs objects
    if (!startDate || !endDate || !startDate.isValid || !endDate.isValid) {
      console.warn('Invalid dates in selectedDate in FttsLandingPage:', { startDate, endDate });
      return;
    }

    // Check if both dates are the same (single day selection)
    if (startDate.isSame(endDate, 'day')) {
      const isCurrentDate = startDate.isSame(dayjs(), 'day');

      if (isCurrentDate && alramType === 'live') {
        // For live alarms on current date, use 24 hours ago to current time
        const now = dayjs();
        const twentyFourHoursAgo = now.subtract(24, 'hour');
        setVideoPlayTimeFromStart(
          `${twentyFourHoursAgo.format('YYYY-MM-DD')} ${twentyFourHoursAgo.format('HH:mm:ss')}`
        );
        setVideoPlayTime(
          `${twentyFourHoursAgo.format('YYYY-MM-DD')} ${twentyFourHoursAgo.format('HH:mm:ss')}`
        );
        setVideoPlayTimeEnd(`${now.format('YYYY-MM-DD')} ${now.format('HH:mm:ss')}`);
      } else {
        // For history alarms or past dates, use the selected date
        setVideoPlayTimeFromStart(`${startDate.format('YYYY-MM-DD')} 00:00:00`);
        setVideoPlayTime(`${startDate.format('YYYY-MM-DD')} 00:00:00`);
        setVideoPlayTimeEnd(`${startDate.format('YYYY-MM-DD')} 23:59:59`);
      }
    } else {
      // Date range selection - use the actual start and end dates
      setVideoPlayTimeFromStart(`${startDate.format('YYYY-MM-DD')} 00:00:00`);
      setVideoPlayTime(`${startDate.format('YYYY-MM-DD')} 00:00:00`);
      setVideoPlayTimeEnd(`${endDate.format('YYYY-MM-DD')} 23:59:59`);
    }
  }, [selectedDate]);

  const fetchData = async () => {
    if (alramType === Generals.history) {
      try {
        setLoading(true);
        setLoadingApi(false);
        const response = await apiClient.get(
          valueTab === Generals.ftts
            ? isNewFttsImplementation()
              ? `/snmpFTTS/historicAlarms`
              : `/ftts/historicAlarms`
            : valueTab === Generals.mpbn
              ? `/mpbn/historicAlarms`
              : valueTab === Generals.otn
                ? isNewOtnImplementation()
                  ? `/snmpOTN/historicAlarms`
                  : `/otn/historicAlarms`
                : valueTab === Generals.ipran
                  ? isNewIpranImplementation()
                    ? `/snmpIPRAN/historicAlarms`
                    : `/ipran/historicAlarms`
                  : '/snmpFTTS/historicAlarms',
          {
            params: {
              region: filtersValue?.region,
              city: filtersValue?.city,
              ...(valueTab !== Generals.otn && { ring: filtersValue?.ring }),
              dateTime: videoPlayTimeFromStart,
              endDateTime: videoPlayTimeEnd,
            },
          }
        );
        setLoading(false);
        setLoadingApi(true);
        if (
          selectedTab === Generals.ftts ||
          selectedTab === Generals.mpbn ||
          selectedTab === Generals.otn ||
          selectedTab === Generals.ipran
        ) {
          // tabValue === Generals.ftts || Generals.mpbn ? setData(response?.data) : setData(response?.data.response);

          setData(
            selectedTab === Generals.ftts || selectedTab === Generals.mpbn
              ? response?.data
              : response?.data?.response || []
          );
          if (response?.data?.length) {
            // Optionally handle the response data
          }
        } else {
          setData([]);
          setLoadingApi(true);
        }
      } catch (error) {
        handleApiError(error);
        setData([]);
        setLoadingApi(true);
        setLoading(false);
      }
    } else {
      setData([]);
    }
  };

  const fetchDataFromSocketGeneric = useCallback(
    (namespace, responseEvent, sessionKey) => {
      showBackdrop();
      setLoadingApi(false);

      if (socketRef.current) {
        socketRef.current.disconnect();
      }

      socketRef.current = io(`${apiUrl}`, {
        rememberUpgrade: true,
        transports: ['websocket'],
        secure: true,
        rejectUnauthorized: false,
      });

      socketRef.current.on('connect', () => {
        socketRef.current.emit(namespace, {
          region: tabCheck !== selectedTab ? '' : filtersValue?.region,
          city: filtersValue?.city,
          ring: filtersValue?.ring,
          link: filtersValue?.link,
          site: filtersValue?.site,
        });

        socketRef.current.on('initial:alarms', (data) => {
          alarmsAllData = data;
          setData(data);
          setLoadingApi(true);
        });

        socketRef.current.on(responseEvent, (data) => {
          if (alramType === Generals.live) {
            setData(data);
            setLoadingApi(true);
            if (data?.length !== Number(sessionStorage.getItem(sessionKey))) {
              sessionStorage.setItem(sessionKey, data?.length);
            }
          }
        });
      });

      socketRef.current.on('disconnect', () => {
        hideBackdrop();
      });

      hideBackdrop();
    },
    [filtersValue, alramType, tabCheck, selectedTab]
  );

  useEffect(() => {
    if (alramType === Generals.live) {
      setData([]);
      switch (selectedTab) {
        case Generals.ftts:
          fetchDataFromSocketGeneric('alarm', 'alarms:response', Generals.totalFttsAlarms);
          break;
        case Generals.mpbn:
          fetchDataFromSocketGeneric('mpbn', 'mpbn:response', Generals.totalMpbnAlarms);
          break;
        case Generals.otn:
          fetchDataFromSocketGeneric('otn', 'otn:response', Generals.totalOtnAlarms);
          break;
        case Generals.ipran:
          fetchDataFromSocketGeneric('ipran', 'ipran:response', Generals.totalIpranAlarms);
          break;
        default:
          break;
      }
    } else {
      fetchData(); // history
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [filtersValue, alramType, videoPlayTime, valueTab, videoPlayTimeEnd]);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
    setState({
      top: false,
      left: false,
      bottom: false,
      right: false,
    });
    handleReset();
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: !state.right });
  };

  useEffect(() => {
    fetchFiltersData();
  }, [state, valueTab]);

  const fetchFiltersData = async () => {
    try {
      if (!valueTab) {
        return null;
      }
      const response = await apiClient.get(
        valueTab === Generals.ftts
          ? `/ftts/sitesInventory`
          : valueTab === Generals.mpbn
            ? `/mpbn/sitesInventory`
            : valueTab === Generals.otn
              ? `/otn/sitesInventory`
              : valueTab === Generals.ipran
                ? `/ipran/sitesInventory`
                : null
      );
      const responseData =
        valueTab === Generals.otn || valueTab === Generals.ipran
          ? response?.data?.response
          : response?.data;
      setFiltersData(responseData);

      let initialRegions = [];
      let initialCities = [];
      let initialSites = [];
      let initialLinks = [];
      let initialRings = [];

      if (valueTab === Generals.ftts) {
        initialRegions = Object.keys(responseData).filter(Boolean);
        initialCities = Object.keys(responseData).flatMap((region) =>
          Object.keys(responseData[region] || {}).filter(Boolean)
        );
        initialRings = Object.values(responseData).flatMap((region) =>
          Object.values(region || {})
            .flatMap((city) => city?.ringNames || [])
            .filter(Boolean)
        );
        initialSites = Object.values(responseData).flatMap((region) =>
          Object.values(region || {})
            .flatMap((city) => city?.siteCodes || [])
            .filter(Boolean)
        );
        initialLinks = initialRegions.flatMap((region) =>
          Object.values(responseData[region] || {})
            .flatMap((city) => city?.linkNames || [])
            .filter(Boolean)
        );
      }
      if (valueTab === Generals.mpbn) {
        const cityNamesSet = new Set();
        const siteNamesSet = new Set();
        const trunkNames = [];

        Object.keys(responseData || {}).forEach((city) => {
          if (city) {
            cityNamesSet.add(city);
          }

          Object.keys(responseData[city] || {}).forEach((site) => {
            if (site) {
              siteNamesSet.add(site);
            }

            const trunkNameArray = responseData[city][site]?.trunkNames || [];
            trunkNames.push(...trunkNameArray.filter(Boolean));
          });
        });

        initialCities = [...cityNamesSet].filter(Boolean);
        initialSites = [...siteNamesSet].filter(Boolean);
        initialLinks = trunkNames.filter(Boolean);
      }
      if (valueTab === Generals.otn) {
        initialRegions = Object.keys(responseData || {}).filter(Boolean);
        initialCities = Object.keys(responseData || {}).flatMap((region) =>
          Object.keys(responseData[region] || {}).filter(Boolean)
        );
        initialSites = initialRegions.flatMap((region) =>
          Object.keys(responseData[region] || {}).flatMap((city) =>
            Object.keys(responseData[region][city] || {}).filter(Boolean)
          )
        );
        initialLinks = initialRegions.flatMap((region) =>
          Object.keys(responseData[region] || {}).flatMap((city) =>
            Object.keys(responseData[region][city] || {})
              .flatMap((site) => responseData[region][city][site]?.linkNames || [])
              .filter(Boolean)
          )
        );
      }
      if (valueTab === Generals.ipran) {
        initialRegions = Object.keys(responseData || {}).filter(Boolean);
        initialCities = Object.keys(responseData || {}).flatMap((region) =>
          Object.keys(responseData[region] || {}).filter(Boolean)
        );
        initialSites = initialRegions.flatMap((region) =>
          Object.keys(responseData[region] || {}).flatMap((city) =>
            Object.keys(responseData[region][city] || {}).filter(Boolean)
          )
        );
        initialLinks = initialRegions.flatMap((region) =>
          Object.keys(responseData[region] || {}).flatMap((city) =>
            Object.keys(responseData[region][city] || {})
              .flatMap((site) => responseData[region][city][site]?.linkNames || [])
              .filter(Boolean)
          )
        );
      }

      setInitialFilters({
        region: initialRegions,
        city: initialCities,
        ring: initialRings, // Set this accordingly if needed
        link: initialLinks,
        site: initialSites,
      });

      setRegions(initialRegions.filter(Boolean));
      setCities(initialCities.filter(Boolean));
      setRings(initialRings.filter(Boolean)); // Set this accordingly if needed
      setLinks(initialLinks.filter(Boolean));
      setSites(initialSites.filter(Boolean));
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    if (ring && filtersData) {
      let selectedCity, selectedRegion;
      for (const region in filtersData) {
        for (const city in filtersData[region]) {
          if (filtersData[region][city]?.ringNames?.includes(ring)) {
            selectedCity = city;
            selectedRegion = region;
            break;
          }
        }
        if (selectedCity) {
          break;
        }
      }

      if (selectedRegion && selectedCity) {
        setRegion(selectedRegion);
        setCity(selectedCity);
        setCities(Object.keys(filtersData[selectedRegion] || {}).filter(Boolean));

        const selectedRings = filtersData[selectedRegion][selectedCity]?.ringNames || [];
        setRings(selectedRings.filter(Boolean));

        const selectedLinks = filtersData[selectedRegion][selectedCity]?.linkNames || [];
        setLinks(selectedLinks.filter(Boolean));

        const filteredSites = (filtersData[selectedRegion][selectedCity]?.siteCodes || []).filter(
          (site) => (filtersData[selectedRegion][selectedCity]?.siteCodes || []).includes(site)
        );
        setSites(filteredSites.filter(Boolean));
      }
    }
  }, [ring, filtersData]);

  const handleRegionChange = (selectedRegion) => {
    if (filtersData && filtersData[selectedRegion]) {
      // Update cities based on the selected region
      const selectedCities = Object.keys(filtersData[selectedRegion] || {}).filter(Boolean);
      setCities(selectedCities);

      // Update rings and links based on the selected region
      const rings = selectedCities
        .flatMap((city) => filtersData[selectedRegion][city]?.ringNames || [])
        .filter(Boolean);
      const links = selectedCities
        .flatMap((city) => filtersData[selectedRegion][city]?.linkNames || [])
        .filter(Boolean);
      setRings(rings);
      setLinks(links);
    } else {
      // Reset cities, rings, and links to include all values if selectedRegion is not found
      const allRegions = Object.keys(filtersData || {}).filter(Boolean);
      const allCities = allRegions.flatMap((region) =>
        Object.keys(filtersData[region] || {}).filter(Boolean)
      );
      const allRings = allRegions.flatMap((region) =>
        Object.values(filtersData[region] || {})
          .flatMap((city) => city?.ringNames || [])
          .filter(Boolean)
      );
      const allLinks = allRegions.flatMap((region) =>
        Object.values(filtersData[region] || {})
          .flatMap((city) => city?.linkNames || [])
          .filter(Boolean)
      );

      setCities(allCities);
      setRings(allRings);
      setLinks(allLinks);
    }
  };
  const handleCityChange = (selectedCity) => {
    if (valueTab === Generals.ftts) {
      if (selectedCity) {
        const selectedRegion = Object.keys(filtersData || {}).find((region) =>
          filtersData[region]?.hasOwnProperty(selectedCity)
        );
        setRegion(selectedRegion);

        // Update rings and links based on the selected city
        const rings = filtersData[selectedRegion]?.[selectedCity]?.ringNames || [];
        const links = filtersData[selectedRegion]?.[selectedCity]?.linkNames || [];
        const sites = filtersData[selectedRegion]?.[selectedCity]?.siteCodes || [];
        setRings(rings.filter(Boolean));
        setLinks(links.filter(Boolean));
        setSites(sites.filter(Boolean));
      } else {
        // Reset rings and links to include all values if selectedCity is not found
        const rings = Object.values(filtersData[region] || {})
          .flatMap((city) => city?.ringNames || [])
          .filter(Boolean);
        const links = Object.values(filtersData[region] || {})
          .flatMap((city) => city?.linkNames || [])
          .filter(Boolean);
        setRings(rings);
        setLinks(links);
      }
    } else if (valueTab === Generals.otn) {
      if (selectedCity) {
        // Find the region that contains the selected city
        const selectedRegion = Object.keys(filtersData || {}).find(
          (region) => filtersData[region] && filtersData[region][selectedCity]
        );

        if (selectedRegion) {
          setRegion(selectedRegion);

          // Get the sites (like GUJ3302, HSL3510) for the selected city
          const sites = Object.keys(filtersData[selectedRegion][selectedCity] || {}).filter(
            Boolean
          );

          // Get the links for all sites within the selected city
          const links = sites
            .flatMap((site) => filtersData[selectedRegion][selectedCity][site]?.linkNames || [])
            .filter(Boolean);

          setSites(sites);
          setLinks(links);
        }
      } else {
        // Reset if no city is selected
        const allRegions = Object.keys(filtersData || {}).filter(Boolean);
        const allCities = allRegions.flatMap((region) =>
          Object.keys(filtersData[region] || {}).filter(Boolean)
        );
        const allSites = allCities.flatMap((city) => {
          const region = Object.keys(filtersData || {}).find((region) =>
            filtersData[region]?.hasOwnProperty(city)
          );
          return Object.keys(filtersData[region]?.[city] || {}).filter(Boolean);
        });
        const allLinks = allCities.flatMap((city) => {
          const region = Object.keys(filtersData || {}).find((region) =>
            filtersData[region]?.hasOwnProperty(city)
          );
          return Object.keys(filtersData[region]?.[city] || {})
            .flatMap((site) => filtersData[region]?.[city]?.[site]?.linkNames || [])
            .filter(Boolean);
        });

        setSites(allSites);
        setLinks(allLinks);
      }
    } else if (valueTab === Generals.ipran) {
      if (selectedCity) {
        // Find the region that contains the selected city
        const selectedRegion = Object.keys(filtersData || {}).find(
          (region) => filtersData[region] && filtersData[region][selectedCity]
        );

        if (selectedRegion) {
          setRegion(selectedRegion);

          // Get the sites (like GUJ3302, HSL3510) for the selected city
          const sites = Object.keys(filtersData[selectedRegion][selectedCity] || {}).filter(
            Boolean
          );

          // Get the links for all sites within the selected city
          const links = sites
            .flatMap((site) => filtersData[selectedRegion][selectedCity][site]?.linkNames || [])
            .filter(Boolean);
          setSite('');
          setLink('');
          setSites(sites);
          setLinks(links);
        }
      } else {
        // Reset if no city is selected
        const allRegions = Object.keys(filtersData || {}).filter(Boolean);
        const allCities = allRegions.flatMap((region) =>
          Object.keys(filtersData[region] || {}).filter(Boolean)
        );
        const allSites = allCities.flatMap((city) => {
          const region = Object.keys(filtersData || {}).find((region) =>
            filtersData[region]?.hasOwnProperty(city)
          );
          return Object.keys(filtersData[region]?.[city] || {}).filter(Boolean);
        });
        const allLinks = allCities.flatMap((city) => {
          const region = Object.keys(filtersData || {}).find((region) =>
            filtersData[region]?.hasOwnProperty(city)
          );
          return Object.keys(filtersData[region]?.[city] || {})
            .flatMap((site) => filtersData[region]?.[city]?.[site]?.linkNames || [])
            .filter(Boolean);
        });

        setSites(allSites);
        setLinks(allLinks);
      }
    } else if (valueTab === Generals.mpbn) {
      if (selectedCity) {
        // Update trunks and sites based on the selected city
        const sites = Object.keys(filtersData[selectedCity] || {}).filter(Boolean);
        const trunks = sites
          .flatMap((site) => filtersData[selectedCity][site]?.trunkNames || [])
          .filter(Boolean);
        setSites(sites);
        setLinks(trunks);
      } else {
        // Reset trunks and sites to include all values if selectedCity is not found
        const allCities = Object.keys(filtersData || {}).filter(Boolean);
        const allSites = allCities.flatMap((city) =>
          Object.keys(filtersData[city] || {}).filter(Boolean)
        );
        const allTrunks = allCities.flatMap((city) =>
          Object.values(filtersData[city] || {})
            .flatMap((site) => site?.trunkNames || [])
            .filter(Boolean)
        );

        setSites(allSites);
        setLinks(allTrunks);
      }
    }
  };

  const handleLinkChange = (selectedLink) => {
    if (valueTab === Generals.ftts) {
      if (selectedLink) {
        let selectedCity, selectedRegion, selectedRing;

        //  selectedRing=getRingName(null,selectedLink)
        // Find the city and region for the selected link
        for (const region in filtersData) {
          for (const city in filtersData[region]) {
            if (filtersData[region][city].linkNames.includes(selectedLink)) {
              selectedCity = city;
              selectedRegion = region;
              break;
            }
          }
          if (selectedCity) {
            break;
          } // Exit loop if city is found
        }

        // Update state with selected region and city
        setRegion(selectedRegion);
        setCity(selectedCity);
        setCities(Object.keys(filtersData[selectedRegion]));

        // Update rings and links based on the selected city
        const rings = filtersData[selectedRegion][selectedCity].ringNames;
        const links = filtersData[selectedRegion][selectedCity].linkNames.filter((link) =>
          link.includes(selectedLink)
        );
        setRings(rings);
        setLinks(links);

        // Filter sites based on selected link
        const filteredSites = filtersData[selectedRegion][selectedCity].siteCodes.filter((site) =>
          selectedLink.includes(site)
        );

        // Update sites with filtered results
        setSites(filteredSites);
        // setSite('');
      }
    } else if (valueTab === Generals.otn) {
      if (selectedLink) {
        let selectedRegion, selectedCity, selectedSite;

        // Find the region, city, and site for the selected link
        for (const region in filtersData) {
          for (const city in filtersData[region]) {
            for (const site in filtersData[region][city]) {
              if (filtersData[region][city][site].linkNames.includes(selectedLink)) {
                selectedRegion = region;
                selectedCity = city;
                selectedSite = site;
                break;
              }
            }
            if (selectedSite) {
              break;
            } // Exit loop if site is found
          }
          if (selectedCity) {
            break;
          } // Exit loop if city is found
        }

        // Update state with selected region, city, and site
        setRegion(selectedRegion);
        setCity(selectedCity);
        setCities(Object.keys(filtersData[selectedRegion]));
        setSites([selectedSite]);

        // Update links based on the selected site
        const links = filtersData[selectedRegion][selectedCity][selectedSite].linkNames;
        setLinks(links);
      } else {
        // Reset to include all values if selectedLink is not found
        const allRegions = Object.keys(filtersData);
        const allCities = allRegions.flatMap((region) => Object.keys(filtersData[region]));
        const allSites = allRegions.flatMap((region) =>
          Object.values(filtersData[region]).flatMap((city) => Object.keys(city))
        );
        const allLinks = allRegions.flatMap((region) =>
          Object.values(filtersData[region]).flatMap((city) =>
            Object.values(city).flatMap((site) => site.linkNames)
          )
        );

        setCities(allCities);
        setSites(allSites);
        setLinks(allLinks);
      }
    } else if (valueTab === Generals.ipran) {
      if (selectedLink) {
        let selectedRegion, selectedCity, selectedSite;

        // Find the region, city, and site for the selected link
        for (const region in filtersData) {
          for (const city in filtersData[region]) {
            for (const site in filtersData[region][city]) {
              if (filtersData[region][city][site].linkNames.includes(selectedLink)) {
                selectedRegion = region;
                selectedCity = city;
                selectedSite = site;
                break;
              }
            }
            if (selectedSite) {
              break;
            } // Exit loop if site is found
          }
          if (selectedCity) {
            break;
          } // Exit loop if city is found
        }

        // Update state with selected region, city, and site
        setRegion(selectedRegion);
        setCity(selectedCity);
        setCities(Object.keys(filtersData[selectedRegion]));
        setSites([selectedSite]);

        // Update links based on the selected site
        const links = filtersData[selectedRegion][selectedCity][selectedSite].linkNames;
        setLinks(links);
      } else {
        // Reset to include all values if selectedLink is not found
        const allRegions = Object.keys(filtersData);
        const allCities = allRegions.flatMap((region) => Object.keys(filtersData[region]));
        const allSites = allRegions.flatMap((region) =>
          Object.values(filtersData[region]).flatMap((city) => Object.keys(city))
        );
        const allLinks = allRegions.flatMap((region) =>
          Object.values(filtersData[region]).flatMap((city) =>
            Object.values(city).flatMap((site) => site.linkNames)
          )
        );

        setCities(allCities);
        setSites(allSites);
        setLinks(allLinks);
      }
    } else {
      if (selectedLink) {
        let selectedCity, selectedSite;

        // Find the city and site for the selected link/trunk
        for (const city in filtersData) {
          for (const site in filtersData[city]) {
            const linkOrTrunkNames =
              valueTab === Generals.mpbn
                ? filtersData[city][site].trunkNames || []
                : filtersData[city][site].linkNames || [];

            if (linkOrTrunkNames.includes(selectedLink)) {
              selectedCity = city;
              selectedSite = site;
              break;
            }
          }
          if (selectedCity) {
            break;
          } // Exit loop if city is found
        }

        // Update state with selected city and site
        setCity(selectedCity);
        setSites([selectedSite]);

        // Update links/trunks based on the selected site
        const linksOrTrunks =
          valueTab === Generals.mpbn
            ? filtersData[selectedCity][selectedSite].trunkNames
            : filtersData[selectedCity][selectedSite].linkNames;
        setLinks(linksOrTrunks);
      } else {
        // Reset to include all values if selectedLink is not found
        const allCities = Object.keys(filtersData);
        const allSites = allCities.flatMap((city) => Object.keys(filtersData[city]));
        const allLinksOrTrunks = allCities.flatMap((city) =>
          Object.values(filtersData[city]).flatMap((site) =>
            valueTab === Generals.mpbn ? site.trunkNames || [] : site.linkNames || []
          )
        );

        setCities(allCities);
        setSites(allSites);
        setLinks(allLinksOrTrunks);
      }
    }
  };

  const handleSiteChange = async (selectedSite) => {
    if (valueTab === Generals.ftts) {
      if (selectedSite) {
        let selectedCity, selectedRegion, selectedRing;

        // selectedRing=getRingName(selectedSite)
        // Find the city and region for the selected site
        for (const region in filtersData) {
          for (const city in filtersData[region]) {
            if (filtersData[region][city].siteCodes.includes(selectedSite)) {
              selectedCity = city;
              selectedRegion = region;
              break;
            }
          }
          if (selectedCity) {
            break;
          } // Exit loop if city is found
        }

        // Update state with selected region and city
        setRegion(selectedRegion);
        setCity(selectedCity);
        //
        setCities(Object.keys(filtersData[selectedRegion]));

        // Update rings and links based on the selected city
        const rings = filtersData[selectedRegion][selectedCity].ringNames;
        const links = filtersData[selectedRegion][selectedCity].linkNames.filter((link) =>
          link.includes(selectedSite)
        );
        setRings(rings);
        setLinks(links);

        // Filter sites based on selected site
        const filteredLinks = filtersData[selectedRegion][selectedCity].linkNames.filter((link) =>
          link.includes(selectedSite)
        );

        // Update links with filtered results
        setLinks(filteredLinks);
        setLink('');
      } else {
        // Reset to include all values if selectedSite is not found
        const allRegions = Object.keys(filtersData);
        const allCities = allRegions.flatMap((region) => Object.keys(filtersData[region]));
        const allRings = allRegions.flatMap((region) =>
          Object.values(filtersData[region]).flatMap((city) => city.ringNames)
        );
        const allLinks = allRegions.flatMap((region) =>
          Object.values(filtersData[region]).flatMap((city) => city.linkNames)
        );

        setCities(allCities);
        setRings(allRings);
        setLinks(allLinks);
      }
    } else if (valueTab === Generals.mpbn) {
      if (selectedSite) {
        let selectedCity;

        // Find the city for the selected site
        for (const city in filtersData) {
          if (filtersData[city]?.hasOwnProperty(selectedSite)) {
            selectedCity = city;
            break;
          }
        }

        // Update state with selected city
        setCity(selectedCity);

        // Update trunks based on the selected site
        const trunks = filtersData[selectedCity][selectedSite].trunkNames;
        setLinks(trunks);

        // Update sites to include only the selected site
        setSites([selectedSite]);
      } else {
        // Reset to include all values if selectedSite is not found
        const allCities = Object.keys(filtersData);
        const allSites = allCities.flatMap((city) => Object.keys(filtersData[city]));
        const allTrunks = allCities.flatMap((city) =>
          Object.values(filtersData[city]).flatMap((site) => site.trunkNames)
        );

        setCities(allCities);
        setSites(allSites);
        setLinks(allTrunks);
      }
    } else if (valueTab === Generals.otn) {
      if (selectedSite) {
        let selectedCity, selectedRegion;

        // Find the city and region for the selected site
        for (const region in filtersData) {
          for (const city in filtersData[region]) {
            if (filtersData[region][city].hasOwnProperty(selectedSite)) {
              selectedCity = city;
              selectedRegion = region;
              break;
            }
          }
          if (selectedCity) {
            break;
          } // Exit loop if city is found
        }

        // Update state with selected region and city
        setRegion(selectedRegion);
        setCity(selectedCity);

        // Set the cities based on the selected region
        setCities(Object.keys(filtersData[selectedRegion]));

        // Get the links related to the selected site
        const links = filtersData[selectedRegion][selectedCity][selectedSite].linkNames;

        // Update links with filtered results
        setLinks(links);

        // Set sites to include only the selected site
        setSites([selectedSite]);
      } else {
        // Reset to include all values if selectedSite is not found
        const allRegions = Object.keys(filtersData);
        const allCities = allRegions.flatMap((region) => Object.keys(filtersData[region]));
        const allSites = allCities.flatMap((city) =>
          Object.keys(
            filtersData[
              Object.keys(filtersData).find((region) => filtersData[region].hasOwnProperty(city))
            ][city]
          )
        );
        const allLinks = allCities.flatMap((city) =>
          Object.keys(
            filtersData[
              Object.keys(filtersData).find((region) => filtersData[region].hasOwnProperty(city))
            ][city]
          ).flatMap(
            (site) =>
              filtersData[
                Object.keys(filtersData).find((region) => filtersData[region].hasOwnProperty(city))
              ][city][site].linkNames
          )
        );

        setCities(allCities);
        setSites(allSites);
        setLinks(allLinks);
      }
    } else if (valueTab === Generals.ipran) {
      if (selectedSite) {
        let selectedCity, selectedRegion;

        // Find the city and region for the selected site
        for (const region in filtersData) {
          for (const city in filtersData[region]) {
            if (filtersData[region][city].hasOwnProperty(selectedSite)) {
              selectedCity = city;
              selectedRegion = region;
              break;
            }
          }
          if (selectedCity) {
            break;
          } // Exit loop if city is found
        }

        // Update state with selected region and city
        setRegion(selectedRegion);
        setCity(selectedCity);

        // Set the cities based on the selected region
        setCities(Object.keys(filtersData[selectedRegion]));

        // Get the links related to the selected site
        const links = filtersData[selectedRegion][selectedCity][selectedSite].linkNames;

        // Update links with filtered results
        setLinks(links);

        // Set sites to include only the selected site
        setSites([selectedSite]);
      } else {
        // Reset to include all values if selectedSite is not found
        const allRegions = Object.keys(filtersData);
        const allCities = allRegions.flatMap((region) => Object.keys(filtersData[region]));
        const allSites = allCities.flatMap((city) =>
          Object.keys(
            filtersData[
              Object.keys(filtersData).find((region) => filtersData[region].hasOwnProperty(city))
            ][city]
          )
        );
        const allLinks = allCities.flatMap((city) =>
          Object.keys(
            filtersData[
              Object.keys(filtersData).find((region) => filtersData[region].hasOwnProperty(city))
            ][city]
          ).flatMap(
            (site) =>
              filtersData[
                Object.keys(filtersData).find((region) => filtersData[region].hasOwnProperty(city))
              ][city][site].linkNames
          )
        );

        setCities(allCities);
        setSites(allSites);
        setLinks(allLinks);
      }
    }
  };
  const handleTabSelection = (tabValue) => {
    setValueTab(tabValue);
    sessionStorage.setItem('selectedTab', tabValue);
    // handleDrawerClose();
    navigate('/fibers');
  };
  const handleApplyChanges = (regionValue) => {
    setFiltersValue({ region: regionValue, city, ring, link, site });
    if (regionValue || city || ring || link || site) {
      setApplyFilters(false);
    }
    return;
  };
  const handleApply = () => {
    setFiltersValue({ region, city, ring, link, site });
    if (region || city || ring || link || site) {
      setApplyFilters(true);
    }
  };
  const handleReset = () => {
    setFiltersValue({ region: '', city: '', ring: '', link: '', site: '' });
    setApplyFilters(false);
    setRegion('');
    setCity('');
    setRing('');
    setLink('');
    setSite('');
    setRings(Array.isArray(initialFilters.ring) ? initialFilters.ring.filter(Boolean) : []);
    setCities(Array.isArray(initialFilters.city) ? initialFilters.city.filter(Boolean) : []);
    setRegions(Array.isArray(initialFilters.region) ? initialFilters.region.filter(Boolean) : []);
    setLinks(Array.isArray(initialFilters.link) ? initialFilters.link.filter(Boolean) : []);
    setSites(Array.isArray(initialFilters.site) ? initialFilters.site.filter(Boolean) : []);
    if (markerRef.current) {
      markerRef.current.remove();
      markerRef.current = null;
    }
  };
  const list = (anchor) => (
    <FilterDrawer
      selectedTab={selectedTab}
      regions={regions}
      cities={cities}
      rings={rings}
      sites={sites}
      links={links}
      region={region}
      setRegion={setRegion}
      city={city}
      setCity={setCity}
      ring={ring}
      setRing={setRing}
      site={site}
      setSite={setSite}
      link={link}
      setLink={setLink}
      handleRegionChange={handleRegionChange}
      handleCityChange={handleCityChange}
      handleSiteChange={handleSiteChange}
      handleLinkChange={handleLinkChange}
      handleReset={handleReset}
      handleApply={handleApply}
    />
  );
  return (
    <DashboardLayout
      handleReset={handleReset}
      handleDrawerClose={handleDrawerClose}
      state={state}
      list={list}
      totalAlarms={data}
      value={valueTab}
      setValue={setValueTab}
      toggleDrawer={toggleDrawer}
      applyFilters={applyFilters}
      selectedTab={selectedTab}
      regions={regions}
      cities={cities}
      rings={rings}
      sites={sites}
      links={links}
      region={region}
      setRegion={setRegion}
      city={city}
      setCity={setCity}
      ring={ring}
      setRing={setRing}
      site={site}
      setSite={setSite}
      link={link}
      setLink={setLink}
      handleRegionChange={handleRegionChange}
      handleCityChange={handleCityChange}
      handleSiteChange={handleSiteChange}
      handleLinkChange={handleLinkChange}
      handleApply={handleApply}
      setFiltersValue={setFiltersValue}
    >
      {open !== true && (
        <>
          {/* For left Bar */}
          <Grid container>
            <Grid item xs={11.5}>
              <Box
                sx={{
                  position: 'absolute',
                  top: '40%',
                  zIndex: 999,
                  cursor: 'pointer',
                }}
                onClick={handleDrawerOpen}
              >
                <img alt="" src={expandButton} style={{ width: '43px', height: '152px' }} />
              </Box>
            </Grid>
          </Grid>
        </>
      )}
      <Box sx={{ flexGrow: 1, p: 0 }}>
        <Grid container spacing={0}>
          {open === true && (
            <Grid
              className={`alert_notification_grid ${open ? 'open_alert_drawer' : 'close_alert_drawer'} `}
            >
              <div className="alerts_main">
                <HeadingFttsLandingPageButton handleDrawerClose={handleDrawerClose} />
                <ActiveAlarmsCard
                  data={data}
                  tabCheck={tabCheck}
                  setLoadingApi={setLoadingApi}
                  loadingApi={loadingApi}
                  handleReset={handleReset}
                  handleApplyChanges={handleApplyChanges}
                  value={valueTab}
                  loading={loading}
                  totalAlarms={totalAlarms}
                  setTotalAlarms={setTotalAlarms}
                  setSelectedAlarm={setSelectedAlarm}
                  setFiltersValue={setFiltersValue}
                  filtersValue={filtersValue}
                  setRing={setRing}
                  setCity={setCity}
                  setRegion={setRegion}
                  alarmType={alramType}
                />
              </div>
            </Grid>
          )}
          <div
            className={`alert_notification_grid ${open ? 'open_alert_content' : 'close_alert_content'} `}
            style={{ position: 'relative' }}
          >
            {viewType === 'graph' ? (
              <IpranMap
                handleReset={handleReset}
                setViewType={setViewType}
                data={data}
                regionData={regionData}
                markerRef={markerRef}
                viewType={viewType}
                state={state}
                loading={loading}
                selectedAlarm={selectedAlarm}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                ring={filtersValue?.ring}
                region={filtersValue?.region}
                city={filtersValue?.city}
                site={filtersValue?.site}
                link={filtersValue?.link}
                setVideoPlayTime={setVideoPlayTime}
                setVideoPlayTimeFromStart={setVideoPlayTimeFromStart}
                setVideoPlayTimeEnd={setVideoPlayTimeEnd}
                alramType={alramType}
                setAlramType={setAlramType}
                open={open}
                toggleDrawer={toggleDrawer}
                applyFilters={applyFilters}
              />
            ) : (
              <ActiveAlarmsTable
                viewType={viewType}
                setViewType={setViewType}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                data={alramType === 'live' ? data : null}
                state={state}
                loading={loading}
                selectedAlarm={selectedAlarm}
                ring={filtersValue?.ring}
                region={filtersValue?.region}
                city={filtersValue?.city}
                filtersValue={filtersValue}
                setVideoPlayTime={setVideoPlayTime}
                setVideoPlayTimeEnd={setVideoPlayTimeEnd}
                setVideoPlayTimeFromStart={setVideoPlayTimeFromStart}
                alramType={alramType}
                setAlramType={setAlramType}
                open={open}
                toggleDrawer={toggleDrawer}
                applyFilters={applyFilters}
              />
            )}
            <NetworkMonitoringButtons
              selectedTab={selectedTab}
              onTabChange={handleTabSelection}
              onReset={handleReset}
              onSetFiltersValue={setFiltersValue}
              onDrawerClose={handleDrawerClose}
            />
          </div>
        </Grid>
      </Box>
    </DashboardLayout>
  );
}
